import { useEffect, useState } from "react";

export default function useViewOptions(currentUser) {
  const [isTeacherView, setIsTeacherView] = useState(false);
  const [isStudentView, setIsStudentView] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      setIsTeacherView(false);
      setIsStudentView(false);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser && isTeacherView) {
      setIsStudentView(false);
    }
  }, [currentUser, isTeacherView]);

  useEffect(() => {
    if (currentUser && isStudentView) {
      setIsTeacherView(false);
    }
  }, [currentUser, isStudentView]);

  return {
    isTeacherView,
    setIsTeacherView,
    isStudentView,
    setIsStudentView,
  };
}
